import {
  primaryColors,
  transparentColors,
  whiteShades
} from '@/assets/styles/helpers/colors.styles'

export const OtpInputStyles = {
  // Share the row evenly so the group matches the width of the fields above it.
  flex: '1 1 0',
  minWidth: 0,
  aspectRatio: '1 / 1',
  maxHeight: '56px',
  padding: '0',
  borderRadius: '8px',
  textAlign: 'center',
  color: primaryColors.white,
  background: transparentColors.transparent,

  border: `2px solid ${whiteShades.shade1}`,
  boxShadow: 'none',

  '& input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },

  '& .MuiInputBase-input': {
    textAlign: 'center'
  },

  '&:hover': {
    borderColor: primaryColors.white
  },

  '&:focus': {
    boxShadow: 'none'
  },

  '&:focus-visible': {
    outline: '0'
  }
}
